import { Grid } from '@material-ui/core';
import SkeletonPulse from './SkeletonPulse';

const FlagHeaderLoader = () => {
  return (
    <div className="square-container-header">
      <Grid container spacing={3} direction="row" alignItems="center">
        <Grid item>
          <SkeletonPulse height="60" width="60" backgroundColor="#364250" />
        </Grid>
        <Grid item>
          <SkeletonPulse height="15" width="500" backgroundColor="#364250" />
        </Grid>
      </Grid>
    </div>
  );
};

export default FlagHeaderLoader;
